<template>
  <div class="main-container">
    <div class="main-content">
      <HeroNews/>
      <TodayMatches/>
      <topLeagues/>
      <LeagueStats/>
    </div>
    <SidebarLeft/>

  </div>
</template>

<script>
import HeroNews from '@/components/HeroNews.vue'
import SidebarLeft from '@/components/SidebarLeft.vue'
import TodayMatches from "@/components/TodayMatches.vue";
import TopLeagues from "@/components/TopLeagues.vue";
import LeagueStats from "@/components/LeagueStats.vue";

export default {
  name: 'HomeView',
  components: {
    LeagueStats,
    TopLeagues,
    TodayMatches,
    HeroNews,
    SidebarLeft
  }
}
</script>

<style lang="scss">
@import '@/assets/sass/variables';
@import '@/assets/sass/mixin';

#app {
  direction: rtl;
}

.main-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 18px;
  width: 100%;
  margin: 0 auto;
  padding: 16px 16px 0;
}

.main-content {
  flex: 1;
  min-width: 0;
}

/* ===== موبایل ===== */
@include mobile {
  .main-container {
    flex-direction: column;
    gap: 0;
    padding: 0;
  }

  .main-content {
    width: 100%;
    order: 1;
  }

  /* SidebarLeft — جدول لیگ و برنامه بازی‌ها — بعد از محتوا */
  .sidebar-left {
    width: 100% !important;
    order: 2;
    margin: 0 !important;
  }
}

/* ===== لپ‌تاپ (1025–1200) =====
   سایدبار ۳۰۰px کامل در این بازه جا برای محتوای اصلی تنگ می‌کند */
@media (min-width: 1025px) and (max-width: 1200px) {
  .sidebar-left {
    width: 260px !important;
    flex-shrink: 0;
  }
}

/* ===== تبلت ===== */
@include tablet {
  .main-container {
    padding: 12px 10px 0;
    gap: 10px;
  }
}
</style>